import {BaseView} from "../core/view"

export default BaseView.extend({

    el: '.js-search-contents-wrapper',

    events: {
        'click .js-search-contents-expand': 'onClickExpand'
    },

	initialize: function() {
    },

    onClickExpand: function (el) {
        el.currentTarget.classList.add('search-contents__expand--hidden');
        $('.js-search-contents-expandable').addClass('search-contents-expandable--expanded');
    }
})
